import { Spin } from "antd";
import React from "react";
import "../../common.scss";
function Loader() {
  return (
    <div className="loader">
      <Spin size="large" />
    </div>
  );
}

export default Loader;
